import { useRef, useState, useEffect } from 'react';

function useDebounce(value, delay, onChange) {
  const isInitial = useRef(false);
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    if (!isInitial.current) {
      isInitial.current = true;
      return;
    }
    const handler = setTimeout(() => {
      setDebouncedValue(() => value);
      if (onChange) {
        onChange(value);
      }
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [delay, value, onChange]);
  return debouncedValue;
}

export { useDebounce as default };
//# sourceMappingURL=useDebounce.mjs.map
